define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaFeeSchedule = void 0;
    class WaFeeSchedule extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NoDays", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NoDaysError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeEx", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeExError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Fee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaFeeSchedule.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Wa = parent;
            this.WaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Wa = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaId = (0, EntityUtil_1.toInt)(entity.WaId);
            a.StartDt = b.StartDt;
            a.EndDt = b.EndDt;
            a.NoDays = (0, EntityUtil_1.toInt)(entity.NoDays);
            a.FeeEx = (0, EntityUtil_1.toFloat)(entity.FeeEx);
            a.Fee = (0, EntityUtil_1.toFloat)(entity.Fee);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaFeeSchedule.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WaId", "Water Agreement ID");
                this.validateReqDate(validationState, "StartDt", "Effective Start Date");
                this.validateReqNumber(validationState, "NoDays", "No of Schedule Days");
                this.validateReqNumber(validationState, "FeeEx", "Prorata Fee (no deductions)", { precision: 2 });
                this.validateReqNumber(validationState, "Fee", "Prorata Fee (after deductions)", { precision: 2 });
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaId: this.WaId,
                StartDt: this.StartDt,
                EndDt: this.EndDt,
                NoDays: this.NoDays,
                FeeEx: this.FeeEx,
                Fee: this.Fee,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.WaFeeSchedule = WaFeeSchedule;
    Object.defineProperty(WaFeeSchedule, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaFeeSchedule"
    });
    Object.defineProperty(WaFeeSchedule, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Water Agreement Fee Schedule"
    });
    Object.defineProperty(WaFeeSchedule, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaId", "StartDt", "EndDt", "NoDays", "FeeEx", "Fee"]
    });
    Object.defineProperty(WaFeeSchedule, "WaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaFeeSchedule, "StartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaFeeSchedule, "EndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaFeeSchedule, "NoDaysReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaFeeSchedule, "FeeExReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaFeeSchedule, "FeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "WaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "WaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "StartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "StartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "EndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "EndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "NoDays", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "NoDaysError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "FeeEx", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "FeeExError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "Fee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "FeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaFeeSchedule.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaFeeSchedule.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaFeeSchedule.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaFeeSchedule.prototype, "merge", null);
});
